import { Fab } from '@mui/material';
import { styled } from '@mui/system';
import { DayButtonProps } from './types';

export const DayButton = styled(Fab)<DayButtonProps>(({ theme, selected }) => ({
  boxShadow: 'none',
  border: `1px solid ${theme.palette.text.disabled}`,
  color: selected ? '#000' : theme.palette.text.primary,
  background: selected ? theme.palette.grey[300] : 'transparent',
  width: 35,
  height: 35,
  marginLeft: 4,
  '&:hover': {
    backgroundColor: !selected
      ? theme.palette.grey[600]
      : theme.palette.grey[400],
  },
}));
